import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { onBasePath } from '../../paths/onBasePath';
import { DataSubjectDetails } from './DataSubjectDetails';
import { DataSubjectDirectory } from './directoryFilter/DataSubjectDirectory';
import { DataSubjectEdit } from './DataSubjectEdit';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { DataSubjectBreadcrumbsData } from './DataSubjectBreadcrumbs';
import translations from './DataSubjects.translations.json';
import { cleanArray } from '@atlas-frontend/sdk';
import { NotFound } from '../NotFound';
import { path } from '../../paths';

const { addTranslations, Translation } = i18nNsFactory('data-subjects');
addTranslations(translations);

const getRenderBreadcrumb =
  (suffix: 'details' | 'edit' | 'create') =>
  ({ dataSubject }: DataSubjectBreadcrumbsData = {}) =>
    dataSubject?.code || dataSubject?.name ? (
      cleanArray([dataSubject?.code, dataSubject?.name]).join(' ')
    ) : (
      <Translation>{(t) => t(`breadcrumb.data-subject-${suffix}`)}</Translation>
    );

export const DATA_SUBJECT_ROUTES = [
  {
    path: path.dataSubjectDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.data-subjects')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <DataSubjectDirectory />,
      },
      {
        path: path.dataSubjectView,
        renderBreadcrumb: getRenderBreadcrumb('details'),
        element: <DataSubjectDetails />,
      },
      {
        path: path.dataSubjectEdit,
        renderBreadcrumb: getRenderBreadcrumb('edit'),
        element: <DataSubjectEdit />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const DataSubjects: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, DATA_SUBJECT_ROUTES));
